import React from 'react';
import { toast } from '@cotera/client/app/components';
import { useWhoami } from '@cotera/client/app/stores/org';
import { useAuth } from '@workos-inc/authkit-react';
import { Button } from '../../ui/button';
import { useSlackBotInstallation } from '../use-slack-bot-installation';
import { ConnectedStatusCard } from '../credential-connection-cards';
import { triggerSlackBotInstall } from './slack-oauth-install-popout';
import type { CredentialStrategyViewProps } from './credential-strategy-view-props';

export const SlackOauthInstallStrategyView: React.FC<
  CredentialStrategyViewProps
> = ({ strategy, onSuccess }) => {
  const orgId = useWhoami((s) => s.org.id);
  const { user } = useAuth();
  const userId = user?.id;
  const { installed: isCocoInstalled } = useSlackBotInstallation();

  const { description } = strategy;

  if (isCocoInstalled) {
    return (
      <ConnectedStatusCard
        title="Coco installed in Slack"
        description={description}
        variant="success"
        isActive={true}
      />
    );
  }

  return (
    <Button
      onClick={() => {
        if (userId === undefined || userId.length === 0) {
          toast.error('Unable to determine user ID for Slack authorization');
          return;
        }

        try {
          triggerSlackBotInstall({ orgId, userId }, onSuccess);
        } catch {
          toast.error('Failed to open Slack authorization popup');
        }
      }}
    >
      {description}
    </Button>
  );
};
